<template>
  <div>
    <van-sticky :offset-top="46">
      <van-search
        v-model="queryParams.productName"
        shape="round"
        show-action
        background="#4fc08d"
        clearable
        placeholder="请输入搜索关键词"
      >
        <template #action>
          <div style="padding: 0px 4px;" @click="handleRefresh">搜索</div>
        </template>
      </van-search>
    </van-sticky>
    <page-list ref='pageList' request-url="/product" :getParams="getQueryParams">
      <template #row="{row}">
        <div style="background-color:rgba(172,201,220,0.19);line-height: 32px;border-radius: 6px;padding: 6px 10px">
          <van-row>
            <van-col span="24">商品: {{row.productName}}</van-col>
          </van-row>
          <van-row>
            <van-col span="24">所属分类: {{row.categoryName}}</van-col>
          </van-row>
          <van-row >
            <van-col span="12">销售价: <span style="font-weight: 500;font-size: 20px;color: #07c160">{{row.salePrice}}</span> (元/{{row.unit}})</van-col>
            <van-col span="12">供应商价: <span style="font-weight: 500;font-size: 20px;color: #f5222d">{{row.supplierPrice}}</span> (元/{{row.unit}})</van-col>
          </van-row>
        </div>
      </template>
    </page-list>
  </div>
</template>

<script>
import PageList from '@/components/tools/PageList'
export default {
  name: 'OrderList',
  components: { PageList },
  created () {
    this.queryParams.deliveryDate = this.$moment(new Date()).format('YYYY-MM-DD')
    this.purchaseDay = this.$moment(new Date()).format('YYYY-MM-DD')
  },
  data () {
    const that = this
    return {
      url: {
        imgerver: window._CONFIG.staticDomainUrl
      },
      show: false,
      allOrder: false,
      model: {},
      queryParams: {
        productName: null
      },
      minDate: new Date(that.$moment(new Date()).subtract(1, 'months').startOf('month').format('YYYY-MM-DD'))
    }
  },
  computed: {

  },
  methods: {
    getQueryParams (params) {
      const param = Object.assign({}, params)
      param.productName = this.queryParams.productName
      param.isShelf = 1
      return { params: param }
    },
    handleRefresh () {
      this.$refs.pageList.onRefresh(20, false)
    },
    openOutDrawer (row) {
      this.model = {}
      this.model.id = row.id
      this.$set(this.model, 'stockQuantity', 0.1)
      this.$set(this.model, 'outRemark', '')
      // this.model.chargeAmount = 0
      this.$refs.adjustDrawer.show = true
    },
    onOutStock () {
      // 触发表单验证
      this.$refs.form.validate().then(() => {
        this.$api.shop.outStock(this.model.id,
          { quantity: this.model.stockQuantity, remark: this.model.outRemark }).then(response => {
          if (response.success) {
            this.$toast.success('出库成功')
          } else {
            this.$toast.fail(response.message)
          }
          this.$refs.adjustDrawer.show = false
          this.handleRefresh()
        }).catch(() => {
        })
      }).catch((err) => {
        console.log('验证失败', err)
      })
    },
    openScrapDrawer (row) {
      this.model = {}
      this.model.id = row.id
      this.$set(this.model, 'scrapQuantity', 0.1)
      this.$set(this.model, 'scrapRemark', '')
      this.$refs.scrapDrawer.show = true
    },
    onScrapStock () {
      // 触发表单验证
      this.$refs.scrapForm.validate().then(() => {
        this.$api.shop.scrapStock(this.model.id,
          { quantity: this.model.scrapQuantity, remark: this.model.scrapRemark }).then(response => {
          if (response.success) {
            this.$toast.success('操作成功')
          } else {
            this.$toast.fail(response.message)
          }
          this.$refs.scrapDrawer.show = false
          this.handleRefresh()
        }).catch(() => {
        })
      }).catch((err) => {
        console.log('验证失败', err)
      })
    }
  }

}
</script>

<style lang="less" scoped>
  .avatar{
    width: 84px;
    height: 84px;
    vertical-align: middle;
    padding: 8px 0px;
    border-radius: 50%;
  }
</style>
